import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, Quote, BookOpen, Image, Award } from "lucide-react";

export default function Dashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div data-testid="dashboard-loading">Loading...</div>;

  const stats = [
    { k: data.total_supporters, l: "Supporters", icon: Users },
    { k: data.total_endorsements, l: "Endorsements", icon: Quote },
    { k: data.total_research, l: "Research", icon: BookOpen },
    { k: data.total_gallery, l: "Gallery", icon: Image },
    { k: data.total_awards, l: "Awards", icon: Award },
  ];

  return (
    <div data-testid="admin-dashboard" className="space-y-10">
      <header>
        <div className="label-eyebrow mb-2">Overview</div>
        <h1 className="font-display text-4xl text-[hsl(var(--primary))]">Campaign Dashboard</h1>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {stats.map((s) => (
          <div key={s.l} className="bg-white border border-[hsl(var(--border-c))] p-5" data-testid={`stat-${s.l.toLowerCase()}`}>
            <s.icon className="text-[hsl(var(--accent))]" size={20} />
            <div className="font-display text-4xl mt-3 text-[hsl(var(--primary))]">{s.k}</div>
            <div className="text-xs uppercase tracking-widest text-[hsl(var(--fg-muted))] mt-1">{s.l}</div>
          </div>
        ))}
      </div>

      <div>
        <h2 className="font-display text-2xl text-[hsl(var(--primary))] mb-4">Recent Supporters</h2>
        <div className="bg-white border border-[hsl(var(--border-c))]">
          <table className="w-full text-sm">
            <thead className="bg-[hsl(var(--bg-muted))]">
              <tr>
                <th className="text-left p-3 font-medium uppercase text-[10px] tracking-widest">Name</th>
                <th className="text-left p-3 font-medium uppercase text-[10px] tracking-widest">Phone</th>
                <th className="text-left p-3 font-medium uppercase text-[10px] tracking-widest">Email</th>
                <th className="text-left p-3 font-medium uppercase text-[10px] tracking-widest">When</th>
              </tr>
            </thead>
            <tbody>
              {data.recent_supporters.map((r) => (
                <tr key={r.id} className="border-t border-[hsl(var(--border-c))]">
                  <td className="p-3">{r.name}</td>
                  <td className="p-3">{r.phone}</td>
                  <td className="p-3">{r.email || "—"}</td>
                  <td className="p-3 text-[hsl(var(--fg-muted))]">{new Date(r.created_at).toLocaleString()}</td>
                </tr>
              ))}
              {data.recent_supporters.length === 0 && (
                <tr><td colSpan={4} className="p-6 text-center text-[hsl(var(--fg-muted))]">No supporters yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
